/* tslint:disable */
/* eslint-disable */
/**
 * DevourPlay OpenAPI (Swagger) Documentation
 * This is the API documentation generated from the swagger comments in the backend. These correspond directly to the client library.
 *
 * The version of the OpenAPI document: N/A
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface DuplicateOverwolfMapperItem
 */
export interface DuplicateOverwolfMapperItem {
    /**
     * 
     * @type {string}
     * @memberof DuplicateOverwolfMapperItem
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateOverwolfMapperItem
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateOverwolfMapperItem
     */
    source: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateOverwolfMapperItem
     */
    newSource?: string;
    /**
     * 
     * @type {string}
     * @memberof DuplicateOverwolfMapperItem
     */
    gameId?: string;
}

/**
 * Check if a given object implements the DuplicateOverwolfMapperItem interface.
 */
export function instanceOfDuplicateOverwolfMapperItem(value: object): value is DuplicateOverwolfMapperItem {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('source' in value) || value['source'] === undefined) return false;
    return true;
}

export function DuplicateOverwolfMapperItemFromJSON(json: any): DuplicateOverwolfMapperItem {
    return DuplicateOverwolfMapperItemFromJSONTyped(json, false);
}

export function DuplicateOverwolfMapperItemFromJSONTyped(json: any, ignoreDiscriminator: boolean): DuplicateOverwolfMapperItem {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'source': json['source'],
        'newSource': json['newSource'] == null ? undefined : json['newSource'],
        'gameId': json['gameId'] == null ? undefined : json['gameId'],
    };
}

export function DuplicateOverwolfMapperItemToJSON(json: any): DuplicateOverwolfMapperItem {
    return DuplicateOverwolfMapperItemToJSONTyped(json, false);
}

export function DuplicateOverwolfMapperItemToJSONTyped(value?: DuplicateOverwolfMapperItem | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'source': value['source'],
        'newSource': value['newSource'],
        'gameId': value['gameId'],
    };
}

